import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useIdleTimer from '../hooks/useIdleTimer';
import { TORONTO_KIOSK_ID, getCorrectAnswers } from '../utils';

import { db } from '../firebase/config';
import { collection, query, where, getCountFromServer } from 'firebase/firestore';

import Question from '../components/Question';

const Quiz = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const prizeWonToday = useRef(null);

  const { i18n } = useTranslation();

  const quiz = useSelector(({ data: { EN, FR } }) => (i18n.language === 'en' ? EN : FR));

  const navigate = useNavigate();

  const goNextQuestion = () => {
    setCurrentQuestion((prev) => {
      if (prev >= quiz.length - 1) {
        const correctAnswers = getCorrectAnswers();

        navigate('/results', { state: { correctAnswers, prizeWonToday: prizeWonToday.current } });

        return prev;
      }

      return prev + 1;
    });
  };

  useEffect(() => {
    if (!localStorage.getItem('user-info')) navigate('/');
  }, [navigate]);

  useEffect(() => {
    const getPrizeWonToday = async () => {
      const collectionRef = collection(db, `participants`, `k:${TORONTO_KIOSK_ID}`, new Date().toDateString());
      const q = query(collectionRef, where('prize', '!=', null));

      const countObj = await getCountFromServer(q);

      prizeWonToday.current = countObj.data().count;

      console.log(`#prize:`, countObj.data().count);
    };

    if (currentQuestion === 9) getPrizeWonToday();
  }, [currentQuestion]);

  useIdleTimer('quiz');

  return (
    <>
      {quiz && <Question quiz={quiz[currentQuestion]} totalQuestionNum={quiz.length} goNextQuestion={goNextQuestion} />}
    </>
  );
};

export default Quiz;
